import PayConfig from '../common/payment/PayConfig'
import type { Unit, WalletName, Wallet } from '../common/payment/PayConfig'
import { RoleName } from '@/global'
import authenticator from 'authenticator'

const user = (session): UserType => //server session from SSR
{
  // let csession = useSession()//client session and live reloading by global.reloadsession()
  // let session: any = { user: csession?.data?.user?.email ? (csession?.data?.user) : (ssession?.user) }

  // if (session && session.path) {
  //   session.path = ssession.path
  // }
  const P = PayConfig();

  var wallets: { [key in WalletName]: Wallet } | any = {};
  var unit = P.units[session?.user?.unit || "toman"]
  if (session?.user?.email) {
    for (let w of Object.keys(P.wallets)) {
      wallets[w] = P.wallets[w];
      wallets[w].balance = session?.user?.wallets[w] || 0
    }
  }


  var obj: UserType = {
    loggedin: !!session?.user?.email,
    name: session?.user?.name || "unknown user",
    uid: session?.user?.uid || null,
    secret: session?.user?.secret || null,
    xmpppass: session?.user?.xmpppass || null,
    email: session?.user?.email,
    avatar: session?.user?.image,
    image: session?.user?.image,
    imageprop: session?.user?.imageprop || {},
    ccode: session?.user?.ccode,
    tempsecret: {
      generate: () => {
      if (!session?.user) {
        return null
      }
      return authenticator.generateToken(session.user.tempsecret)
    },
    verify: (input:string)=>{
      let valid = !!authenticator.verifyToken(session.user.tempsecret, input);
      return valid
    }
  },
    cchar: session?.user?.cchar,
    phone: session?.user?.phone,
    joindate: session?.user?.joindate,
    lastseen: session?.user?.lastseen,
    signature: session?.user?.signature,
    mfaenabled: session?.user?.mfaenabled,
    role: (session?.user?.role || []) as Array<RoleName>,
    verify: session?.user?.role || session?.user?.verify,
    donate: session?.user?.donate,
    donated: session?.user?.donated,
    esaves: session?.user?.esaves,
    jsaves: session?.user?.jsaves,
    cart: session?.user?.cart || {},
    cmntcount: session?.user?.cmntcount || 0,
    suspend: session?.user?.suspend || false,
    path: session?.path,
    cdn: session?.user?.cdn,
    unit,
    wallets,
    follows: session?.user?.follows || [],
    unreadchats: (session?.user?.unreadchats) || {},
    primarywallet: Object.values<any>(wallets).find(w => w.unit.key == unit.key),
    limited: session?.user?.limited,
    touserunit: function (wallet) { //userunitamount
      let userunit = P.units[session?.user?.unit || "toman"]
      if (wallet.unit.key == (session?.user?.unit || "toman")) {
        return wallet.balance
      }
      let usdamount = wallet.balance * wallet.unit.tousd
      let userunitamount = (usdamount / userunit.tousd)
      if (userunit.removedigits) {
        userunitamount = userunitamount - userunitamount % Math.pow(10, userunit.removedigits);
      }
      return userunitamount || 0
    },
  }

  return obj;
}


export type UserType = {
  loggedin: boolean
  name: string | null
  uid: string | null
  secret: string | null
  tempsecret: {generate:() => string, verify: (input:string)=>boolean},
  xmpppass: string | null
  email: string | null
  avatar: string | null
  image: string | null
  imageprop: any
  ccode: string | null
  cchar: string | null
  phone: string | null
  esaves: Array<string>,
  jsaves: Array<string>,
  joindate: number
  lastseen: Date
  signature: string,
  mfaenabled: boolean | null
  role: Array<RoleName>
  verify: string | null
  donate: boolean | string | null
  donated: number | null
  cart: any
  cmntcount: number
  suspend: boolean
  path: string | null
  cdn: string | null
  unit: Unit,
  wallets: { [key in WalletName]: Wallet },
  unreadchats: any,
  primarywallet: Wallet
  limited: number | boolean | null
  follows: Array<string>
  touserunit: (wallet: Wallet) => number
}

export default user;